export class UserPasswordStatus { 
    passwordUpdated!: boolean;
    statusMessage!: string;
 }